import React, { useState, useEffect } from "react";
import axios from "axios";
import _ from "lodash";
import { connect } from "react-redux";
import Loading from "../../components/Loading";
import toastr from "toastr";
import history from "../../history";
import Modal from "react-modal";
import { sendOTP, checkOTP } from "../../clientServices/sms";
import { login } from "../../clientServices/login";
import { setDefaultPhone, getOS } from "../../ultil";
import OtpInput from 'react-otp-input';

import InputCustom from "../../components/Input/InputCustom";
import TextTitle from "../../components/Text/TextTitle";
import TextTitle1 from "../../components/Text/TextTitle1";
import TextBody from "../../components/Text/TextBody";
import TextBody2 from "../../components/Text/TextBody2";
import TextHead from "../../components/Text/TextHead";
import TextPrice from "../../components/Text/TextPrice";
import TextPriceOld from "../../components/Text/TextPriceOld";
import TextQuantity from "../../components/Text/TextQuantity";
import TextOutOfStock from "../../components/Text/TextOutOfStock";
import { modalStyleBottom, modalStyleDetail, modalStyleCenter, style } from "../../style";
import { useTheme, styled } from '@mui/material/styles';
import {
  AppBar,
  Box,
  Divider,
  IconButton,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Tab,
  Tabs,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Grid,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
let count = setInterval(function() {}, 1000);

const Login = (props) => {
  const { setIsCart, setIsLogin, isCart, user, globalVariable } = props;
  const {virturalKeyboard} = globalVariable
  const [content, setContent] = useState(null);
  const [phone, setPhone] = useState("");
  const [lastPhone, setLastPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [form, setForm] = useState(0);
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState(0);
  const [link, setLink] = useState("");
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (countdown === 0) {
      setLastPhone("");
      clearInterval(count);
    }
  }, [countdown]);

  useEffect(() => {
    setLoading(false);
  }, [user]);

  useEffect(() => {
    const phoneRefInput = document.getElementById("phone");
    if (phoneRefInput) {
      phoneRefInput.addEventListener("keydown", function(e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });

      phoneRefInput.addEventListener("wheel", function(e) {
        e.preventDefault();
      });
    }

    if (localStorage && localStorage.getItem("phone")) {
      setPhone(atob(localStorage.getItem("phone")));
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (lastPhone !== phone) {
      getCode((err, result) => {
        if (result) {
          setForm(1);
        }
      });
    } else {
      setForm(1);
    }
  };

  const tryAgain = () => {
    getCode();
  };

  const getCode = (cb) => {
    setLoading(true);
    localStorage && localStorage.setItem("phone", btoa(phone));
    sendOTP({ phone,})
      .then((res) => {
        const { code, data } = res;
        setLastPhone(phone);
        setToken(_.get(data, "token", null));
        clearInterval(count);
        setCountdown(180);
        count = setInterval(() => {
          setCountdown((countdown) => countdown - 1);
        }, 1000);
        setLoading(false);
        typeof cb === "function" && cb(null, true);
      })
      .catch(() => {
        setLoading(false);
        typeof cb === "function" && cb(true);
      });
  };

  const loginWithoutPassword = (e, instantOtp) => {
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    setDefaultPhone(phone);
    login({
      code: instantOtp || otp,
      phone: phone,
      token,
    })
      .then((res) => {
        localStorage.setItem("last-check", 0);
        if (res.code === 200) {
          return (document.location.href = link);
        }
        setLoading(false);
        // history.push('/')
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChangePhone = (e) => {
    let { value } = e.target;

    if (value.length <= 3 && ["+84", "84"].includes(value)) {
      value = 0;
    }
    if (value.length > 10) {
      let head = value.substring(0, 4);
      let body = value.substring(4);
      switch (head) {
        case "0162":
          head = "032";
          break;
        case "0163":
          head = "033";
          break;
        case "0164":
          head = "034";
          break;
        case "0165":
          head = "035";
          break;
        case "0166":
          head = "036";
          break;
        case "0167":
          head = "037";
          break;
        case "0168":
          head = "038";
          break;
        case "0169":
          head = "039";
          break;
        case "0120":
          head = "070";
          break;
        case "0121":
          head = "079";
          break;
        case "0122":
          head = "077";
          break;
        case "0123":
          head = "083";
          break;
        case "0124":
          head = "084";
          break;
        case "0125":
          head = "085";
          break;
        case "0126":
          head = "076";
          break;
        case "0127":
          head = "081";
          break;
        case "0128":
          head = "078";
          break;
        case "0129":
          head = "082";
          break;
        case "0186":
          head = "056";
          break;
        case "0188":
          head = "058";
          break;
        case "0199":
          head = "059";
          break;
        default:
      }
      value = head + body;
    }
    if (value.length > 10) {
      return;
    }
    if (value.length === 10) {
      value = value.replace("+", "0");
    }
    setLoading(false);
    setPhone(value);
  };

  const handleChangeOtp = (value) => {
    if (value.length > 4) {
      return;
    }
    if (value.length === 4) {
      checkOTP({
        phone,
        code: value,
        token,
      }).then((res) => {
        return loginWithoutPassword(null, value);
      });
    }
    setOtp(value);
  };

  const btnGoBack = () => {
    setIsLogin(false);
    setIsCart(isCart);
  };

  const closeModal = () => {
    if (form != 1) {
      setIsLogin(false);
      setIsCart(isCart);
    }
  };

  return (<Modal
    isOpen={isOpen}
    style={modalStyleDetail}
    onRequestClose={closeModal}
    ariaHideApp={false}
    className="animated slideInDown"
  >
    {loading && <Loading />}
    <Box sx={[style, {bgcolor: '#ffffff'}]}>
      <Box sx={{ position: 'relative' }}>
        <AppBar
          position="sticky"
          color="inherit"
        >
          <Toolbar sx={{minHeight: '52px'}}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={form ? () => setForm(0) : closeModal}
              sx={{position: 'absolute'}}
            >
              <ArrowBackIcon fontSize="large"/>
            </IconButton>
            <TextTitle1 sx={{flexGrow: 1, textAlign: 'center'}} variant="h5" component="div">
              Đăng nhập
            </TextTitle1>
          </Toolbar>
        </AppBar>

        <Box sx={{textAlign: 'center'}} mt={2}>
          <img width="80px" height="80px" src="/image/logo-heyu-tet.jpg" style={{borderRadius: '16px'}}/>
        </Box>
        <Box mt={2} px={2}>
          <TextTitle1 component="p" color="#012548" sx={{textAlign: 'center'}}>Đăng nhập để tiếp tục mua hàng</TextTitle1>
        </Box>
        <Box mt={2} px={2}>
          <TextBody2 component="p" color="#012548" sx={{textAlign: 'center'}}>{form ? `Một mã xác thực gồm 4 số đã được gửi về số điện thoại ${phone}. Vui lòng nhập mã xác thực vào ô dưới đây để tiến hành quá trình đăng nhập` : 'Hãy nhập chính xác số điện thoại mà bạn sử dụng để tiến hành xác minh. Nhấn vào “Tiếp tục” và HeyU sẽ gửi cho bạn một mã xác thực qua tin nhắn'}</TextBody2>
        </Box>
        <Box mt={2} px={2}>
          {
            form ?
            <OtpInput
            value={otp}
            onChange={handleChangeOtp}
            containerStyle={{
              display: 'flex',
              justifyContent: 'center'
            }}
            numInputs={4}
            inputStyle={{
              width: '44px',
              height: '44px',
              margin: '0 1rem',
              fontSize: '18px',
              borderRadius: '4px',
              border: '1px solid rgba(0, 0, 0, 0.3)',
            }}
            errorStyle="error"
            shouldAutoFocus
            separator={<span></span>}
            isInputNum
            />
            :
            <InputCustom
            autoFocus={true}
            onSubmit={handleSubmit}
            icon={<PhoneIphoneIcon fontSize="large" sx={{mb: '3px'}}/>}
            sx={{px: 2, py: 1, bgcolor: '#F5F6FA', width: '100%', boxShadow: 'none', borderRadius: '16px', display: 'flex', alignItems:'center'}}
            placeholder={"Nhập số điện thoại"}
            autoComplete={"off"}
            type="tel"
            pattern="\d*"
            value={phone}
            onChange={handleChangePhone}
            />
          }
        </Box>
        {
          form?
          <Box mt={2} px={2} sx={{display: 'flex'}}>
            <TextBody2 component="p" color="#012548" sx={{flexGrow: 1}}>Không nhận được mã?</TextBody2>
            <TextBody2 component="p" color="#012548">{countdown ? `gửi lại sau ${countdown} giây` : <a onClick={tryAgain}>Gửi lại</a>}</TextBody2>
          </Box>
          :null
        }
        <Box sx={{position: virturalKeyboard ? 'static' : 'fixed' , width: '100%', maxWidth: '600px', bottom: 0, zIndex: 1, bgcolor: '#ffffff', boxShadow: virturalKeyboard ? 'none' :'0px -2px 8px rgba(92, 83, 83, 0.08)'}}>
          <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 16px'}}>
            <Button disabled={form ? otp.length < 4 : false} onClick={form ? loginWithoutPassword : handleSubmit} fullWidth size="large" variant="contained" sx={{borderRadius: '16px', fontSize: '16px', textTransform: 'none', bgcolor: '#1589D8'}}>
              {form ? 'Đăng nhập' : 'Tiếp tục'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  </Modal>);
}
const mapStateToProps = state => state;
const mapFunctionToProps = {
  // getUserInf,
  // setGlobalVariable
  // getTimeLineOrder,
};
export default connect(mapStateToProps, mapFunctionToProps)(Login)
